import React from "react";
import styled from "styled-components";
import { QUERIES } from "../../constants";
import MaxWidthWrapper from "../MaxWidthWrapper";

export default function Footer() {
  return (
    <Wrapper>
      <MaxWidthWrapper>
        <MainFooter>
          <RouteColumn>
            <Route>Home</Route>
            <Route>Services</Route>
            <Route>News</Route>
            <Route>Data collection</Route>
            <Route>About Us</Route>
          </RouteColumn>
          <RequestForStats>Request for stats</RequestForStats>
        </MainFooter>
        <SubFooter>
          <SubFooterText>TERMS AND CONDITIONS</SubFooterText>
          <MadeBy>StatsGh, made by ElohimStudio</MadeBy>
          <div
            style={{
              flex: 1,
            }}
          ></div>
        </SubFooter>
      </MaxWidthWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.footer`
  background-color: var(--color-ash);
  padding: 120px 0px 80px;
  grid-column: 1 / -1;

  @media ${QUERIES.phoneAndSmaller} {
    padding: 120px 0px 0px;
  }
`;

const MainFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 180px;

  @media ${QUERIES.phoneAndSmaller} {
    flex-direction: column;
    gap: 115px;
    padding-bottom: 60px;
  }
`;

const RouteColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
`;

const Route = styled.h2`
  color: var(--color-grey);
`;

const RequestForStats = styled.h2`
  color: var(--color-grey);

  @media ${QUERIES.phoneAndSmaller} {
    text-align: right;
  }
`;

const SubFooter = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #7e7e7e;
  padding: 18px 0px 0px;

  @media ${QUERIES.phoneAndSmaller} {
    flex-direction: column;
    align-items: center;
    gap: 80px;
  }
`;

const SubFooterText = styled.h5`
  color: var(--color-white);
  text-transform: uppercase;
  text-align: left;
  flex: 1;

  @media ${QUERIES.phoneAndSmaller} {
    font-size: 0.75rem;
  }
`;

const MadeBy = styled(SubFooterText)`
  text-transform: revert;
  text-align: center;
  max-width: 20ch;
  flex: revert;

  @media ${QUERIES.phoneAndSmaller} {
    font-size: 1rem;
  }
`;
